export default {
  // Public events listing (eventos)
  "events.pageTitle": "Eventos — BajApp Xperiences",
  "events.listingTitle": "Eventos en Baja California Sur",
  "events.listingSubtitle": "Festivales, torneos y celebraciones de la zona.",
  "events.emptyListing": "No hay eventos próximos por ahora. Vuelve pronto.",

  // Public single-event detail (evento)
  "events.detailTitleSuffix": "{{title}} — BajApp Xperiences",
  "events.notFound": "No encontramos este evento.",
  "events.viewAll": "Ver todos los eventos",
  "events.backToEvents": "Eventos",
  "events.bookRelated": "Reservar experiencia relacionada",
  "events.moreInfo": "Más información",

  // Home upcoming events section
  "events.upcomingTitle": "Próximos eventos",
  "events.upcomingSubtitle": "Lo que está pasando en Baja California Sur",
  "events.seeAll": "Ver todos",
  "events.viewEvent": "Ver evento",

  // Admin events management
  "events.adminTitle": "Eventos",
  "events.newEvent": "Nuevo evento",
  "events.loadError": "No pudimos cargar los eventos.",
  "events.adminEmpty": "Aún no hay eventos. Crea el primero.",
  "events.colEvent": "Evento",
  "events.colDate": "Fecha",
  "events.colCity": "Ciudad",
  "events.colFeatured": "Destacado",
  "events.colStatus": "Estado",
  "events.statusPublished": "Publicado",
  "events.statusDraft": "Borrador",
  "events.edit": "Editar",
  "events.delete": "Eliminar",
  "events.editEvent": "Editar evento",
  "events.fieldTitle": "Título",
  "events.fieldShortDescription": "Descripción corta (para tarjetas)",
  "events.fieldDescription": "Descripción completa",
  "events.fieldImageUrl": "URL de imagen",
  "events.uploadImage": "Subir imagen",
  "events.uploading": "Subiendo…",
  "events.uploadError": "No pudimos subir la imagen.",
  "events.placeholderImageUrl": "https://… o /brand/…",
  "events.fieldStart": "Inicio",
  "events.fieldEnd": "Fin (opc.)",
  "events.fieldTime": "Hora (opc.)",
  "events.fieldLocation": "Lugar",
  "events.fieldCity": "Ciudad",
  "events.fieldExternalUrl": "Link externo (opc.)",
  "events.placeholderExternalUrl": "https://…",
  "events.fieldTourSlug": "Slug de tour (opc.)",
  "events.placeholderTourSlug": "para botón Reservar",
  "events.fieldOrder": "Orden",
  "events.fieldFeatured": "Destacado (banner)",
  "events.fieldPublished": "Publicado",
  "events.cancel": "Cancelar",
  "events.save": "Guardar",
  "events.errorTitleRequired": "El título es requerido.",
  "events.errorStartRequired": "La fecha de inicio es requerida.",
  "events.errorSave": "Ocurrió un error al guardar.",
  "events.confirmDelete": "¿Eliminar el evento \"{{title}}\"?",
};
